import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { IconEdit, IconTrash, IconZoomIn, IconEye } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { formatDate } from '../../../helpers/formatDate';

const DatatableRiskManagementMonitoring = (props) => {
  // console.log(props);

  const containerStyle = {
    whiteSpace: 'pre-wrap', // Ini yang paling penting
  };

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-outline-warning"
            type="button"
            title="Edit Pemantauan Risiko"
            onClick={() => props.handleEditRiskManagementMonitoring(row)}
          >
            <IconEdit stroke={2} />
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            type="button"
            title="Hapus Pemantauan Risiko"
            onClick={() => props.handleHapusRiskManagementMonitoring(row.id)}
          >
            <IconTrash stroke={2} />
          </button>
        </>
      ),
    },
    // {
    //   name: 'Kegiatan',
    //   minWidth: '300px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <div
    //       style={{
    //         whiteSpace: 'normal',
    //         wordWrap: 'break-word',
    //         textAlign: 'center',
    //         width: '100%',
    //       }}
    //     >
    //       {row?.risk_management_plan?.risk_register?.risk_activity_target?.name}
    //     </div>
    //   ),
    //   style: {
    //     // You can also add more styles here
    //     whiteSpace: 'normal',
    //   },
    // },
    // {
    //   name: 'Sasaran',
    //   minWidth: '300px', // Set a minimum width for horizontal scroll
    //   cell: (row) => (
    //     <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
    //       {
    //         row?.risk_management_plan?.risk_register?.risk_activity_target
    //           ?.goals
    //       }
    //     </div>
    //   ),
    //   style: {
    //     // You can also add more styles here
    //     whiteSpace: 'normal',
    //   },
    // },
    {
      name: 'Akar Masalah',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={
            containerStyle
          }>
            {row.risk_profile?.rootCause}
          </div>
        </>
      ),
    },
    {
      name: 'Yang Belum Tertangani',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={
              containerStyle
            }
          >
            {row?.notYetHandled}
          </div>
        </>
      ),
    },
    {
      name: 'Usulan Perbaikan',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={
              containerStyle
            }
          >
            {row?.improvementIdea}
          </div>
        </>
      ),
    },
    {
      name: 'Waktu Pemantauan',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {formatDate(row?.monitoringTime)}
          </div >
        </>
      ),
    },
    {
      name: 'Realisasi Pemantauan',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row?.monitoringCycle}
          </div>
        </>
      ),
    },
    {
      name: 'Probabilitas Pemantauan (P)',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row?.risk_bobot?.probabilityValue}
          </div>
        </>
      ),
    },
    {
      name: 'Dampak Pemantauan (D)',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row?.risk_bobot?.impactValue}
          </div>
        </>
      ),
    },
    {
      name: 'Bobot',
      minWidth: '100px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row?.risk_bobot?.score}
          </div>
        </>
      ),
    },
    {
      name: 'Nilai',
      minWidth: '100px',
      cell: (row) => {
        const probability = parseInt(row?.risk_bobot?.probabilityValue) || 0;
        const impact = parseInt(row?.risk_bobot?.impactValue) || 0;
        const score = parseFloat(row?.risk_bobot?.score) || 0;
        const result = probability * (impact * score);

        return (
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            <strong>{result}</strong>
          </div>
        );
      },
    },
    {
      name: 'Tingkat Akhir',
      minWidth: '150px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {/* {row?.riskLevel} */}
            {row.riskLevel === 'Sangat Rendah' ? (
              <span className="badge badge-primary text-black">
                Sangat Rendah
              </span>
            ) : row.riskLevel === 'Rendah' ? (
              <span className="badge badge-success text-black">Rendah</span>
            ) : row.riskLevel === 'Sedang' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'yellow' }}
              >
                Sedang
              </span>
            ) : row.riskLevel === 'Tinggi' ? (
              <span
                className="badge text-black"
                style={{ backgroundColor: 'orange' }}
              >
                Tinggi
              </span>
            ) : row.riskLevel === 'Sangat Tinggi' ? (
              <span className="badge badge-danger text-black">
                Sangat Tinggi
              </span>
            ) : (
              ''
            )}
          </div>
        </>
      ),
    },
    {
      name: 'Hasil Pemantauan',
      minWidth: '300px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={
            containerStyle
          }>
            {row.monitoringResult}
          </div>
        </>
      ),
    },
    {
      name: 'Penanggung Jawab Pemantauan',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div
            style={{
              whiteSpace: 'normal',
              wordWrap: 'break-word',
              textAlign: 'center',
              width: '100%',
            }}
          >
            {row?.pic}
          </div>
        </>
      ),
    },
  ];

  const customStyles = {
    rows: {
      style: {
        borderBottom: '1px solid #ddd', // Garis bawah pada setiap baris
      },
    },
    headCells: {
      style: {
        borderBottom: '2px solid #ccc', // Garis bawah yang lebih tebal pada header
        backgroundColor: '#ffc107', // Warna latar belakang header
        fontWeight: 'bold', // Membuat teks header lebih tegas
        textAlign: 'center', // Membuat thead ke tengah
        justifyContent: 'center', // Pusatkan konten secara horizontal
        color: '#FFFF',
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #ddd', // Garis pemisah antar kolom
        padding: '10px', // Padding agar lebih rapi
      },
    },
  };

  return (
    <>
      <div style={{ overflowX: 'auto', maxWidth: '1200px' }}>
        <DataTable
          columns={columns}
          data={props?.listRiskManagementMonitoring}
          customStyles={customStyles}
          pagination
          fixedHeader
          highlightOnHover
          subHeader
          subHeaderComponent={
            <input
              type="text"
              placeholder="Cari Pemantauan Pengendalian"
              className="w-50 form-control m-3"
              values={props.searchMM}
              onChange={(e) => {
                // Hanya izinkan huruf, angka, dan spasi
                const cleanValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                props.handleChangeSearch(cleanValue);
              }}
            />
          }
          subHeaderAlign="center"
        />
      </div>
    </>
  );
};

export default DatatableRiskManagementMonitoring;
